import { useEffect, useRef, useState } from "react";
import VanillaTilt from 'vanilla-tilt';
import { isMobile } from 'react-device-detect';

import { GlowingText2em } from "../../components/glowingtextcomponet/glowingtext2em.js";
import { GlowingText1em } from "../../components/glowingtextcomponet/glowingtext1em.js";

import './experience.css';
import '../view.css';

import cimage from './experienceimage/programinglanguagesimage/c.png';
import cplusplusimage from './experienceimage/programinglanguagesimage/c-plus.png';
import csharpimage from './experienceimage/programinglanguagesimage/c-sharp.png';
import python from './experienceimage/programinglanguagesimage/python.png';
import javaimage from './experienceimage/programinglanguagesimage/java.png';
import shellscriptimage from './experienceimage/programinglanguagesimage/shellscript.png';
import dart from './experienceimage/programinglanguagesimage/dart.png';
import sql from './experienceimage/programinglanguagesimage/sql.png';

import css from './experienceimage/designimage/css.png';
import html from './experienceimage/designimage/html.png';
import javascript from './experienceimage/designimage/javascript.png';

import systemverilog from './experienceimage/hardwaredescriptionlanguageimages/systemverilog.png';

import raspberrypi from './experienceimage/hardware/raspberrypi.png';
import esp32 from './experienceimage/hardware/esp32.png';

import postgresql from './experienceimage/databaseimage/postgresql.png';
import sqlserver from './experienceimage/databaseimage/sqlserver.png';
import mysql from './experienceimage/databaseimage/mysql.png';

import blazor from './experienceimage/frameworksimage/blazor.png';
import dotnet from './experienceimage/frameworksimage/dotnet.png';
import node from './experienceimage/frameworksimage/node.png';
import react from './experienceimage/frameworksimage/react.png';

import flutter from './experienceimage/mobileimage/flutter.png';
import xamarin from './experienceimage/mobileimage/xamarin.png';

export const Experience = () => {
    const gridRef = useRef(null);
    const [tip, setTip] = useState('');
    const [pos, setPos] = useState({ x: 0, y: 0 });

    // Initialise the 3D tilt effect on the skill cards (desktop only).
    useEffect(() => {
        if (isMobile || !gridRef.current) return undefined;
        const boxes = gridRef.current.querySelectorAll('.experiencebox');
        VanillaTilt.init(boxes);
        return () => boxes.forEach((box) => box.vanillaTilt && box.vanillaTilt.destroy());
    }, []);

    // Cursor-following tooltip driven by each card's data-conteudo.
    const handleMouseMove = (event) => {
        const box = event.target.closest('.experiencebox');
        if (box) {
            setTip(box.dataset.conteudo || '');
            setPos({ x: event.pageX, y: event.pageY });
        } else if (tip) {
            setTip('');
        }
    };

    return (

            <div className='view' id='experienceview'>



                <div className="experiencegrid" ref={gridRef} onMouseMove={handleMouseMove} onMouseLeave={() => setTip('')}>
                <div id="balaozinho" style={{ left: pos.x, top: pos.y }}>{tip}</div>

                    <div className="experiencetext" >

                        <div className="experienceeffectcard" id='firstexperiencetextcard'>
                            <div className='experiencelines' id="firstexperienceline"></div>
                            <div className='experiencerow' id='formations'>
                            <GlowingText2em content='Academic Formation'/>
                                <ul>
                                    <li>
                                        <strong>Master's Degree in Computer Science</strong> - <em>UFMG</em>
                                        <ul>
                                            <li>DNN framework for resource-constrained devices — model optimization and efficient inference on edge devices.</li>
                                            <li>FPGA architecture to accelerate deep neural network training under hardware-limited scenarios.</li>
                                            <li><b>Publication:</b> Federated Learning framework for hardware-limited devices, published at <a href="https://sol.sbc.org.br/index.php/sbrc/article/view/35191" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--secundaryblue)' }}>SBRC</a>.</li>
                                        </ul>
                                    </li>

                                    <li>
                                        <strong>Computer Engineering</strong> - <em>CEFET-MG</em>
                                    </li>
                                    <li>
                                        <strong>Computer technician</strong> - <em>S.O.S Computadores</em>
                                        <ul>
                                            <li>
                                                Systems Operator
                                            </li>
                                            <li>
                                                Technical Support Analyst
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="experienceeffectcard" id='secondexperiencetextcard'>
                            <div className='experiencelines' id="secondexperienceline"></div>
                            <div className='experiencerow' id='formations'>
                                <GlowingText2em content='Professional Formation'/>
                                <ul>
                                    <li>
                                        <strong>Data Scientist at SMi Group</strong> <em> Nov 2024 - Present / Remote</em>
                                        <ul>
                                            <li>
                                                Developing Advanced Process Control (APC) solutions, focused on building and applying regression models for industrial process modeling.
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <strong>Intern in Álamo Soluções em TI</strong> <em> set de 2020 - ago de 2021 / 1 year</em>
                                        <ul>
                                            <li>
                                                Mobile system developer in Xamarin plataform.
                                            </li>
                                            <li>
                                                Web system developer in Blazor.
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <strong> FullStack developer in Álamo Soluções em TI</strong>  -  <em>ago de 2021 - out de 2022 / 1 year 3 months</em>
                                        <ul>
                                            <li>
                                               Mobile system developer in Flutter
                                            </li>
                                            <li>
                                                Web system developer in MVC, Blazor .Net and SQLServer database
                                            </li>
                                            <li>
                                                Raspberry IoT system developer
                                            </li>
                                            <li>
                                                Intern coordinator
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>

                        </div>

                    </div>

                    <div className="experienceicons">

                        <div className="experienceeffectcard"  id='thirdexperiencetextcard'>
                            <div className='experiencelines' id="thirdexperienceline"></div>

                            <div className='secondgrid'>

                                <div className='title'>
                                    <GlowingText1em content='Programing Languages' />
                                </div>
                                <div className='experiencerow' >
                                    <div className='experiencebox' id='c' data-titulo="C Language" data-conteudo="That is my main language and the language I started to learn programming, structures and algorithms. currently i use it to programming some microcontrollers like Arduino and ESP32 and I use
it to train some structures and algorithms too" data-tilt>
                                        <h2 className='experiencetitle'> C </h2>
                                        <img src={cimage} alt='cimage' className='experienceimage'></img>
                                    </div>

                                    <div className='experiencebox' id='cpp' data-conteudo='C++ is a C extension language with object orientation. As in the language C I use to train some structures and algorithms and programming some microcontrollers IoT projects, because a lot of them work in C and C++' data-tilt>
                                        <h2 className='experiencetitle' > C++ </h2>
                                        <img src={cplusplusimage} alt='cplusplusimage' className='experienceimage'></img>
                                    </div>

                                    <div className='experiencebox' id='csharp' data-conteudo='This language I use to programming .Net projects using MVC and Blazor framework only. It facilitates because it is a high level programming language' data-tilt>
                                        <h2 className='experiencetitle'> C# </h2>
                                        <img src={csharpimage} alt='csharpimage' className='experienceimage'></img>
                                    </div>

                                    <div className='experiencebox' id='python' data-conteudo='My level on this language is only some college subject projects, some scripts for specific things and professors questions in jupyter notebook  for machine learning  and others' data-tilt>
                                        <h2 className='experiencetitle'> Python </h2>
                                        <img src={python} alt='python' className='experienceimage'></img>

                                    </div>
                                    <div className='experiencebox' id='java' data-conteudo="That is the language I learned object orientation. I only used it in some college subject projects" data-tilt>
                                        <h2 className='experiencetitle'> Java </h2>
                                        <img src={javaimage} alt='javaimage' className='experienceimage'></img>

                                    </div>
                                    <div className='experiencebox' id='sh' data-conteudo='I use to do some sh scripts all the time in help myself in my routine and daily activities' data-tilt>
                                        <h2 className='experiencetitle'> Shell Script </h2>
                                        <img src={shellscriptimage} alt='shellscriptimage' className='experienceimage'></img>

                                    </div>
                                    <div className='experiencebox' id='dart' data-conteudo='I just used dart language for programming mobile apps in Flutter develop interface' data-tilt>
                                        <h2 className='experiencetitle'> Dart </h2>
                                        <img src={dart} alt='dart' className='experienceimage'></img>

                                    </div>
                                    <div className='experiencebox' id='sql' data-conteudo='I work all the time with databases because my preference is backend. I use to manage SGBDs, create and modify database, search, insert update and delete data, create triggers and routines' data-tilt>
                                        <h2 className='experiencetitle'> SQL </h2>
                                        <img src={sql} alt='sql' className='experienceimage'></img>

                                    </div>


                                    </div>
                                    <div className='title'>
                                        <GlowingText1em content='Programing Design' />
                                    </div>
                                    <div className='experiencerow'>
                                        <div className='experiencebox' id='html' data-conteudo='My experience is my own portfolio and in som subject college' data-tilt>
                                            <h2 className='experiencetitle'> HTML </h2>
                                            <img src={html} alt='html' className='experienceimage'></img>
                                        </div>
                                        <div className='experiencebox' id='css' data-conteudo='My experience in CSS is my own portfolio and some subjects college projects. Some times I have to use it to adjust pages layout' data-tilt>
                                            <h2 className='experiencetitle'> CSS </h2>
                                            <img src={css} alt='css' className='experienceimage'></img>
                                        </div>
                                        <div className='experiencebox' id='js' data-conteudo='Java Script is used by me frequentily because I need to communicate with the the backend, make some routines and web functions' data-tilt>
                                            <h2 className='experiencetitle'> JS </h2>
                                            <img src={javascript} alt='javascript' className='experienceimage'></img>
                                        </div>
                                    </div>

                                    <div className='hardwaregrid'>
                                        <div className='hardwaredescription'>
                                            <div className='title'>
                                                <GlowingText1em content='Hardware Description Language' />
                                            </div>
                                            <div className='experiencerow'>
                                                <div className='experiencebox' id='sv' data-conteudo='That is the language I learned organization and computer architecture. I implemented a 8 bit processor, ram memory and a primary gpu. Actually I am working in neural networks applied to FPGA in my master degree' data-tilt>
                                                    <h2 className='experiencetitle'> System Verilog </h2>
                                                    <img src={systemverilog} alt='systemverilog' className='experienceimage'></img>
                                                 </div>
                                            </div>
                                        </div>
                                        <div className='Microcontrollers'>
                                            <div className='title'>
                                                <GlowingText1em content='Microcontrollers and IoT' />
                                            </div>
                                            <div className='experiencerow'>
                                                <div className='experiencebox' id='rbpi' data-conteudo='I worked in a IoT project for smart totem and residence automation both implemented in  .Net. Using sensorial modules and API resources' data-tilt>
                                                    <h2 className='experiencetitle'> Raspberry Pi </h2>
                                                    <img src={raspberrypi} alt='raspberrypi' className='experienceimage'></img>
                                                 </div>
                                                 <div className='experiencebox' id='esp' data-conteudo='I developed some projects working in local network in web service consuming several sensorial modules. My main projects is a drone altitude and altitude control and residence automation' data-tilt>
                                                    <h2 className='experiencetitle'> ESP 32 </h2>
                                                    <img src={esp32} alt='esp32' className='experienceimage'></img>
                                                 </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='title'>
                                        <GlowingText1em content='Databases' />
                                    </div>
                                    <div className='experiencerow'>
                                        <div className='experiencebox' id='sqlserver' data-conteudo='3 years experience' data-tilt>
                                            <h2 className='experiencetitle'> SQLServer </h2>
                                            <img src={sqlserver} alt='sqlserver' className='experienceimage'></img>
                                        </div>
                                        <div className='experiencebox' id='postgresql' data-conteudo='That was the database I started to learn databases, database management system and  the SQL language' data-tilt>
                                            <h2 className='experiencetitle'> PostgreSQL </h2>
                                            <img src={postgresql} alt='postgresql' className='experienceimage'></img>
                                        </div>
                                        <div className='experiencebox' id='mysql' data-conteudo='Only own projects' data-tilt>
                                            <h2 className='experiencetitle'> MySQL </h2>
                                            <img src={mysql} alt='mysql' className='experienceimage'></img>
                                        </div>

                                    </div>
                                    <div className='title'>
                                    <GlowingText1em content='Frameworks and Platforms' />
                                    </div>

                                    <div className='experiencerow'>
                                    <div className='experiencebox' id='dotnet' data-conteudo='I worked in .Net about 3 years in several project. implementing API, security resources  and SQLServer integration with sundry software design pattern' data-tilt>
                                            <h2 className='experiencetitle'> .Net </h2>
                                            <img src={dotnet} alt='dotnet' className='experienceimage'></img>
                                        </div>
                                        <div className='experiencebox' id='blazor' data-conteudo='I worked in some projects building and implementing some CRUDs and Dashboards for clients in the company I worked' data-tilt>
                                            <h2 className='experiencetitle'> Blazor </h2>
                                            <img src={blazor} alt='blazor' className='experienceimage'></img>
                                        </div>
                                        <div className='experiencebox' id='node' data-conteudo='My own portfolio is my single project' data-tilt>
                                            <h2 className='experiencetitle'> NodeJS </h2>
                                            <img src={node} alt='node' className='experienceimage'></img>
                                        </div>
                                        <div className='experiencebox' id='react' data-conteudo='My own portfolio is my single project' data-tilt>
                                            <h2 className='experiencetitle'> React </h2>
                                            <img src={react} alt='react' className='experienceimage'></img>
                                        </div>
                                    </div>
                                    <div className='title'>
                                        <GlowingText1em content='Mobile' />
                                    </div>
                                    <div className='experiencerow'>
                                        <div className='experiencebox' id='flutter' data-conteudo='I implemented one app for iOS and Android using hybrid and shared resource.' data-tilt>
                                            <h2 className='experiencetitle'> Flutter </h2>
                                            <img src={flutter} alt='flutter' className='experienceimage'></img>
                                        </div>
                                        <div className='experiencebox' id='xamarin'  data-conteudo="I implemented one app for Android using geolocation, firebase push notification, background services and API backend consume" data-tilt>
                                            <h2 className='experiencetitle'> Xamarin </h2>
                                            <img src={xamarin} alt='xamarin' className='experienceimage'></img>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>

                </div>
            </div>

    );
};
